import React from 'react';
import { Box, Container } from '@mui/material';
import custom404Img from '../../assets/custom_404/custom_404.png';

const Custom404: React.FC = () => {
    return (
        <Container>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                textAlign: 'center'
            }}>
                <img src={custom404Img} alt='404 page not found' style={{ maxWidth: '100%', height: 'auto' }} />
            </Box>
        </Container>
    )
}
export default Custom404;